module.exports = __webpack_public_path__ + "img/contactus-success.c4a17e17.png";